import React, { useContext, useRef } from "react";
import { useKeyboardCommand } from "@hooks/keyboard/useKeyboardCommand";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { DirectoryContext } from "./Directory.context";
import { DirectoryView } from "./DirectoryView";
import { DirectoryGlDrilldownDrawer } from "./DirectoryGlDrilldownDrawer";
import { CounterpartyEditorDrawer } from "./CounterpartyEditor/CounterpartyEditorDrawer";

export const DirectoryContent: React.FC = () => {
    const {
        addingNew,
        setAddingNew,
        editedItem,
        setEditedItem,
        glDrawerState,
        closeGlDrawer,
    } = useContext(DirectoryContext);
    const { toast } = useToaster();

    const lastEditedItemRef = useRef(editedItem);
    if (editedItem) {
        lastEditedItemRef.current = editedItem;
    }

    const lastGlDrawerStateRef = useRef(glDrawerState);
    if (glDrawerState) {
        lastGlDrawerStateRef.current = glDrawerState;
    }

    useKeyboardCommand({
        keys: "alt+n",
        callback: () => setAddingNew(true),
        options: {
            description: "Add counterparty",
            preventDefault: true,
        },
    });

    return (
        <>
            <DirectoryView />

            <CounterpartyEditorDrawer
                open={addingNew || !!editedItem}
                isCreating={addingNew}
                counterparty={
                    addingNew
                        ? undefined
                        : (editedItem ?? lastEditedItemRef.current)
                }
                onClose={() => {
                    setAddingNew(false);
                    setEditedItem();
                }}
                onCreated={() => {
                    setAddingNew(false);
                }}
                onEdited={(counterparty) => {
                    toast("Counterparty saved");
                    setEditedItem(counterparty);
                }}
                onLocalized={setEditedItem}
            />

            <DirectoryGlDrilldownDrawer
                open={glDrawerState !== null}
                onClose={closeGlDrawer}
                counterpartyId={
                    lastGlDrawerStateRef.current?.counterpartyId ?? null
                }
                isNoCounterparty={
                    lastGlDrawerStateRef.current?.isNoCounterparty ?? false
                }
                accountCode={lastGlDrawerStateRef.current?.accountCode}
            />
        </>
    );
};
